import {useTranslation} from "react-i18next"
import quickReferenceIcon from "../../assets/icon/quick-reference.svg"
import summarizeIcon from "../../assets/icon/summarize.svg"
import formatListBulletedIcon from "../../assets/icon/format-list-bulleted.svg"
import quickPhrasesIcon from "../../assets/icon/quick-phrases.svg"
import unfoldMoreIcon from "../../assets/icon/unfold-more.svg"
import quickReferenceGreyIcon from "../../assets/icon/quick-reference-grey.svg"
import summarizeGreyIcon from "../../assets/icon/summarize-grey.svg"
import formatListBulletedGreyIcon from "../../assets/icon/format-list-bulleted-grey.svg"
import quickPhrasesGreyIcon from "../../assets/icon/quick-phrases-grey.svg"
import unfoldMoreGreyIcon from "../../assets/icon/unfold-more-grey.svg"
import visibilityOnRed from "../../assets/icon/visibility-on-red.svg"
import visibilityOffRed from "../../assets/icon/visibility-off-red.svg"

export default function EcpWorkflowNavigation({project, setIsValueSelector, EcpNavigationTab, handleHtmlPreview, handleEditorValue, isHtmlPreview}) {
    const {t} = useTranslation()
    return (
        <>
        <nav class="ecp-workflow-navigation">
            {!isHtmlPreview &&
            <>
           {!project.finished && <button className="regenerate-icon" title={t("Regenerate")} onClick={() => setIsValueSelector(true)}>{t("Regenerate")}</button>}
            <ul class={`ecp-navigation-tabs ${project.finished && "margin-0"}`}>
                <li id="abstract-tab" class="active" tabindex="0" onClick={() => handleEditorValue("abstract")}>
                    <img src={EcpNavigationTab === "abstract" ? quickReferenceIcon : quickReferenceGreyIcon} alt=""/>
                    <p style={{color: EcpNavigationTab === "abstract" && "#C30F0E"}}>{t("Abstract")}</p>
                </li>
                <li id="summary-tab" tabindex="1" onClick={() => handleEditorValue("summary")}>
                    <img src={EcpNavigationTab === "summary" ? summarizeIcon : summarizeGreyIcon} alt=""/>
                    <p style={{color: EcpNavigationTab === "summary" && "#C30F0E"}}>{t("Summary")}</p>
                </li>
                <li id="keypoints-tab" tabindex="2" onClick={() => handleEditorValue("keypoints")}>
                    <img src={EcpNavigationTab === "keypoints" ? formatListBulletedIcon : formatListBulletedGreyIcon} alt=""/>
                    <p style={{color: EcpNavigationTab === "keypoints" && "#C30F0E"}}>{t("Keypoints")}</p>
                </li>
                <li id="verbatims-tab" tabindex="3" onClick={() => handleEditorValue("verbatims")}>
                    <img src={EcpNavigationTab === "verbatims" ? quickPhrasesIcon : quickPhrasesGreyIcon} alt=""/>
                    <p style={{color: EcpNavigationTab === "verbatims" && "#C30F0E"}}>{t("Verbatims")}</p>
                </li>
                <li id="glossary-tab" tabindex="4" onClick={() => handleEditorValue("glossary")}>
                    <img src={EcpNavigationTab === "glossary" ? unfoldMoreIcon : unfoldMoreGreyIcon} alt=""/>
                    <p style={{color: EcpNavigationTab === "glossary" && "#C30F0E"}}>{t("Glossary")}</p>
                </li>
            </ul>
            </>
            }
            <button className="visibility-icon" title={t("Visibility On")} onClick={() => handleHtmlPreview()}><img src={isHtmlPreview ? visibilityOffRed : visibilityOnRed} alt=""/></button>
        </nav>
        </>
    )
}